
import CarRentaM from '../../viewModels/carRenta/CarRenta'
import './assets/styles.css'

import CarouselServices, { servicesTravel } from '../share/components/CarouselServices/CarouselSevices'
import Find from '../share/components/Find/Find'


import taxi from '../../assets/icons/taxi-background.png'
import ws from '../../assets/images/WsTwo.png'


import viaja from '../../assets/images/viaja.png'
import Check from '../../assets/images/Check.png'
import formImg from '../../assets/images/rent-car.png'
import { Calendar1, ArrowDown2 } from 'iconsax-react';
import { Calendar } from 'react-date-range';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file

const CarRenta = () => {

    const {
        setCiudadDropdown,
        ciudadDropdown,
        setcalendar,
        calendar,
        dated,
        setDated,
        calendarTwo,
        setCalendarTwo,
        date,
        setDate,
        setLocale,
        locale,
        localeOptions,
        locales
    } = CarRentaM();






    return (
        <div>
            <Find></Find>

            <CarouselServices current={servicesTravel[4].title} />

            <section className='contain-buscador-transport-r'>
                <div className='layout-one-t'>
                    <div className='check-title'>
                        <img src={Check} alt="" />
                        <h4>Alquiler de autos, escoge el auto qué mas se adecue a tus necesidades</h4>
                    </div>
                    <div className='contain-form'>
                        <form action="">

                            <div className="campo-t">
                                <label htmlFor="">Ciudad:</label>
                                <div className="input-ca" onClick={() => setCiudadDropdown(!ciudadDropdown)}>
                                    <p>Seleciona Ciudad</p> <span><ArrowDown2 size="20" color="rgb(78, 78, 78)" /></span>
                                </div>

                                {
                                    ciudadDropdown === true &&
                                    <div className='dropdown-ciudad shadow' >
                                        <div style={{ background: "white", borderRadius: "15px", width: "100%" }}>
                                            <input className='input-dropdown' type="text" placeholder='Ciudad' />
                                        </div>
                                    </div>
                                }


                            </div>
                            <div className="campo-t">
                                <label htmlFor="">Oficina de Devolucion:</label>
                                <div className="campo-radio">
                                    <div>
                                        <input type="radio" value={0} name='tipo' required />
                                        <span htmlFor="">Mismo Lugar</span>
                                    </div>
                                    <div>
                                        <input type="radio" value={1} name='tipo' required />
                                        <span htmlFor="">Otro Lugar</span>
                                    </div>
                                </div>
                            </div>
                            <div className="campo-two">
                                <div className='bbb'>
                                    <label htmlFor="">Desde:</label>
                                    <div className="input-ca" onClick={() => setcalendar(!calendar)}>
                                        <p>{dated !== null ? dated.toLocaleDateString('en-us', { year: "numeric", month: "short", day: "numeric" }) : "dd/mm/aaaa"}</p> <span><Calendar1 size="20" color="rgb(78, 78, 78)" /></span>
                                    </div>
                                    <div className='calendar-t-l' >
                                        {
                                            calendar === true &&
                                            <div className='shadow' style={{ display: 'flex', flexFlow: 'column nowrap', background: "white", borderRadius: "15px", }}>
                                                <select
                                                    style={{ margin: '20px auto' }}
                                                    onChange={e => setLocale(e.target.value)}
                                                    value={locale}
                                                >
                                                    {localeOptions.map((option, i) => (
                                                        <option value={option.value} key={i}>
                                                            {option.label}
                                                        </option>
                                                    ))}
                                                </select>
                                                <Calendar onChange={item => {
                                                    setDated(item)
                                                    setcalendar(!calendar)
                                                }}
                                                    locale={locales[locale]} date={dated} />
                                            </div>
                                        }

                                    </div>

                                </div>
                                <div className='bbb'>
                                    <label htmlFor="">Hasta:</label>
                                    <div className="input-ca" onClick={() => setCalendarTwo(!calendarTwo)}>
                                        <p>{date !== null ? date.toLocaleDateString('en-us', { year: "numeric", month: "short", day: "numeric" }) : "dd/mm/aaaa"}</p> <span><Calendar1 size="20" color="rgb(78, 78, 78)" /></span>
                                    </div>
                                    <div className='calendar-t-r' >
                                        {
                                            calendarTwo === true &&
                                            <Calendar onChange={item => {
                                                setDate(item)
                                                setCalendarTwo(!calendarTwo)
                                            }}
                                                locale={locales[locale]} date={dated} />
                                        }

                                    </div>

                                </div>
                            </div>

                            <div className='contain-btn-t'>
                                <button>Buscar Traslado</button>
                            </div>
                        </form>
                        <img className='img-viaja' src={viaja} alt="" />
                    </div>

                </div>
                <div className='layout-two-t'>
                    <img className='fd-img' src={taxi} alt="" />
                    <img className='up-img-r' src={formImg} alt="" />
                </div>
            </section>


            <section className='contain-contact-t'>
             <a href="https://wa.link/uq1q0p" style={{textDecoration:'none'}} target='blank'>
                <div>
                    <img className='img-ws-car' src={ws} alt="" />
                </div>
               
                    <div className='text-contact-t'>
                        <h3>
                            ¿Tienes dudas? ¡Escribenos!
                        </h3>
                        <p>
                            Habla con un asesor vía whatsapp, cuentanos a que lugares quieres ir, que dudas tienes, que servicios necesitas? Estamos para que viajes con todas las comodidades
                        </p>
                    </div>
                </a>
            </section>

        </div>
    )
}

export default CarRenta